import PropTypes from 'prop-types';
import React from 'react';

/**
 * @deprecated please remove and replace with proper link-buttons
 */
const Anchor = ({ onClick, ...others }) => {
  const click = (e) => {
    e.preventDefault();
    if (typeof onClick === 'function') {
      onClick(e);
    }
  };

  /* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid */
  return <a {...others} href="#" onClick={click} />;
  /* eslint-enable jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid */
};

Anchor.propTypes = {
  onClick: PropTypes.func,
};

export default Anchor;
